import React, { useEffect, useState } from 'react';
import { Star, Clock, ShieldCheck } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function TopBanner() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY;
      setIsScrolled(scrollPos > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  const currentDate = new Date().toLocaleDateString('es-AR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  });
  const scrollToPricing = () => {
    const target = document.getElementById('pricing');
    if (!target) return;
    const start = window.scrollY;
    const end = target.getBoundingClientRect().top + start - 80;
    const duration = 2000;
    const startTime = performance.now();
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  return <div className="bg-gradient-to-r from-[#92400e] via-[#d97706] to-[#92400e] text-white py-1 px-4 sticky top-0 left-0 right-0 z-[70] border-b border-white/10 shadow-[0_4px_20px_rgba(0,0,0,0.3)]" data-id="element-326" data-mp="3eo5pw90asnxc">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-2 text-[10px] md:text-xs font-bold uppercase tracking-wider" data-id="element-327" data-mp="180f5ee45qmnf">
        <div className="flex items-center flex-1 justify-center md:justify-start overflow-hidden gap-[0px]" data-id="element-328" data-mp="1crnfzdh84e26">
          <AnimatePresence mode="wait" data-id="element-329" data-mp="y3kas6b096ef">
            {!isScrolled ? <motion.div key="offer-valid" initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="flex items-center text-[8px] md:text-[10px] gap-[6px]" data-id="element-330" data-mp="1323x47tigk7b">
                <span className="bg-white text-[#92400e] px-1.5 py-0.5 rounded whitespace-nowrap shadow-[0_0_8px_rgba(255,255,255,0.4)] text-[10px]" data-id="element-331" data-mp="6ata9jmagvjd">
                  OFERTA VÁLIDA:
                </span>
                <span className="font-black whitespace-nowrap text-white/90 text-[10px]" data-id="element-332" data-mp="2svwccjc8caf">
                  {currentDate}
                </span>
                <div className="flex items-center gap-1.5 ml-2 bg-red-500/20 px-2 py-0.5 rounded border border-red-500/30" data-id="element-333" data-mp="3tydr18tawpk5">
                  <Clock className="w-2.5 h-2.5 text-red-400 animate-pulse" data-id="element-334" data-mp="coz6a4kflf7x" />
                  <span className="text-red-400 font-black tabular-nums text-[10px]" data-id="element-335" data-mp="7t9zph9zuy24">
                    {formatTime(timeLeft)}
                  </span>
                </div>
              </motion.div> : <motion.div key="trust-badges" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: 20
          }} className="flex items-center gap-2 md:gap-4 text-[7px] md:text-[10px]" data-id="element-336" data-mp="3baif7uh91lto">
                <div className="flex items-center pt-[5px] pb-[5px] mt-[0px] mb-[0px] gap-[4px]" data-id="element-337" data-mp="1vru97j8aqs74">
                  <Star className="w-2.5 h-2.5 text-yellow-400 fill-yellow-400" data-id="element-338" data-mp="1ztftvqr2oarv" />
                  <span className="font-black text-white whitespace-nowrap text-[9px]" data-id="element-339" data-mp="24qz84qnrsnjt">
                    +1.500 ALUMNOS
                  </span>
                </div>
                <div className="flex items-center gap-1" data-id="element-340" data-mp="29k27jff8ar7x">
                  <Clock className="w-2.5 h-2.5 text-white" data-id="element-341" data-mp="2egisk0r4spgs" />
                  <span className="font-black text-white whitespace-nowrap text-[9px]" data-id="element-342" data-mp="2jfvqbgjjjgy5">
                    ACCESO INMEDIATO
                  </span>
                </div>
                <div className="flex items-center gap-1" data-id="element-343" data-mp="2ng5vws3f85ch">
                  <ShieldCheck className="w-2.5 h-2.5 text-green-400" data-id="element-344" data-mp="2sfs951j91lla" />
                  <span className="font-black text-white whitespace-nowrap text-[9px]" data-id="element-345" data-mp="t4hbiaef7akp">
                    GARANTÍA 7 DÍAS
                  </span>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </div>;
}